import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "QuestionOptionName",
    isNumber: true,
    isSum: true,
  },
];

export const HealthCenterToHighRiskFactor = {
  label: "衛生所 VS 高風險因子",
  key: "HealthCenterToHighRiskFactor",
  path: "BoneMuscleCare/HealthCenterToHighRiskFactor",
  api: "TCS_V_HighRisk02V",
  render: (options) => (
    <Diagram.BoneMuscleCare.HealthCenterToHighRiskFactor {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "RegionName",
      field: "RegionName",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
